import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <header className='header'>
            <h1 className='logo'>cakepanda</h1>
        </header>
    );
};

export default Header;